import { Button, Flex } from '@patternfly/react-core';
import React from 'react';

const ButtonCustom = ({
  content,
  light,
  isDisabled,
  ...args
}: {
  content: React.ReactNode;
  light?: boolean;
  isDisabled?: boolean;
}) => (
  <Button
    style={{
      background: light ? 'white' : 'var(--pf-global--palette--black-900)',
      border: light ? '1px solid #e6e6e6' : 'none',
      color: light ? 'black' : 'white',
      paddingTop: '8px',
      paddingBottom: '8px',
      fontWeight: light ? 700 : 400,
      opacity: isDisabled ? '0.4' : 1,
    }}
    isDisabled={isDisabled}
    {...args}
  >
    <Flex alignItems={{ default: 'alignItemsCenter' }}>{content}</Flex>
  </Button>
);

export default ButtonCustom;
